import {take} from 'rxjs/operators';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';

export function getCurrentState(aStore: Store<IAppState>): IAppState {

	let state: IAppState;

	aStore.pipe(take(1)).subscribe(s => state = s);

	if (!state) {
		throw new Error('NEEEIN!');
	}

	return state;
}

export function isFilled(variable: any): boolean {
	// Dont refactor to "return variable &&  variable !== ''" as 0 wont be supported
	return variable !== null && variable !== undefined && variable !== '';
}

export function trackById(index: any, value: any): any {
	return value.id;
}

export function trackByIndex(index: any, value: any): any {
	return index;
}

export function urlB64ToUint8Array(base64String): any {
	const padding = '='.repeat((4 - base64String.length % 4) % 4);
	const base64 = (base64String + padding)
		.replace(/\-/g, '+')
		.replace(/_/g, '/');

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}

	return outputArray;
}

export function getUniqueListBy<T>(arr: T[], key: string): T[] {

	return [...new Map(arr.map(item => [item[key], item])).values()];
}

export function splitFullPhoneNumber(fullPhoneNumber: string): { phoneExt: string, phoneNumber: number } {
	let phoneExt: string;
	let phoneNumber: number;

	if (fullPhoneNumber && fullPhoneNumber.match(/\+(\d)*/)) {
		phoneExt = fullPhoneNumber.match(/\+(\d)*/)[0];
		phoneNumber = parseInt(fullPhoneNumber
			.slice(phoneExt.length, fullPhoneNumber.length)
			.replace(/-|\s/g, ''));
	} else {
		phoneExt = null;
		phoneNumber = null;
	}

	return {
		phoneExt,
		phoneNumber,
	};
}

export function isNullOrUndefined(data: any): boolean {
	return data === undefined || data === null;
}
